export default __webpack_public_path__ + "static/media/yuman.ffd6dd13.png";